module.exports = __webpack_public_path__ + "lp/img/camera_icn-darkgray.de9cbb57.svg";